import SearchViewModel from "@arcgis/core/widgets/Search/SearchViewModel";
export async function loadSearchViewModule(mapView) {
    let searchView = new SearchViewModel({
        view: mapView
    });
    return searchView;
}
